module.exports = __webpack_public_path__ + "static/Donate-ac1286c50a7360a94754b2ed0480067e.jpg";